import { z } from "zod";

import { DbEnum } from "../../../../generated/prisma-enums";

/**
 * OAuth service schema using Prisma enum (single source of truth)
 * No transformations, no slugs - use the enum directly everywhere
 */
export const OAuthServiceSchema = z.nativeEnum(DbEnum.OAuthService);

/**
 * START OAuth flow - Request body
 * Uses OAuthService enum directly (no slug conversion)
 */
export const OAuthStartBodySchema = z.object({
  service: OAuthServiceSchema,
  settings: z.record(z.string(), z.unknown()).optional()
});

/**
 * START OAuth flow - Response with authorization URL
 */
export const OAuthStartResponseSchema = z.object({
  authorizationUrl: z.string().url("Invalid authorization URL"),
  handshakeId: z.string().min(1, "Handshake ID is required")
});
